import * as constants from "./../constants";
import { logoutEvent, trackEvent } from '../../analytics';
import * as logger from './../../logger';
import { trackDwebEvent } from "../../desktop/analytics";

import { PARENT_WEBSITE } from "../../desktop/site-config/CrossSiteConfigs";
export const registerUser = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/api/users/register",
    data,
    success: (response) => setUserInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const sendOTP = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/sendotp/" + data.mobileNumber,
    data,
    success: (response) => returnInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const sendAppLink = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "https://staging-api.transportbook.in/sendapplink/" + data.mobileNumber,
    data,
    success: (response) => returnInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const validateOTP = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/validateotp",
    data,
    success: (response) => setUserInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const loginFromWeb = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/get_user_login_info",
    data,
    success: (response) => setUserInfo(response, true),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getUserDetailsV1 = (token, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/user",
    success: (response) => setUserInfoV1(token, response, true),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const setUserInfoV1 = (token, data, loginFromWeb) => {
  data.response.token = token;
  logger.log("AuthActionCreator", "the data is", data);
  let userInfo = {
    userId: null,
    fullName: null,
    token: null,
    tokenInfo: null,
    userInfo: null,
    isLoggedIn: false,
    isNewUser: false,
    showAddTripOverlay: false
  };
  if (data && data.status && data.status.code === 200) {

    if (data && data.response && data.response.token && data.response.user) {
      userInfo = {
        userId: data.response.user.id,
        fullName: data.response.user.id,
        token: data.response.token,
        tokenInfo: data.response.token,
        userInfo: data.response.user,
        isLoggedIn: true,
        isNewUser: false,
        showAddTripOverlay: false
      };
      if (loginFromWeb) {
        userInfo['loginFromWeb'] = loginFromWeb ? loginFromWeb : false
      }
      if (
        // data.response.user.companyName &&
        data.response.user.companyName === "" ||
        data.response.user.companyName === null
      ) {
        userInfo.isNewUser = true;
      };
      localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
      localStorage.removeItem("USER_FROM_WEB");
      localStorage.removeItem("USER_FROM_WEB_ID");
      localStorage.removeItem("USER_FROM_WEB_REFRESH");
    };
  }
  return { type: constants.SET_USER_INFO, payload: userInfo };
};
export const checkOTP = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/validateotp",
    data,
    success: (response) => returnInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getUserDetails = (onSuccess, onError, kaptureIntegration=false) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/user",
    doNotDisplaySpinner: kaptureIntegration,
    success: (response) => setUserInfoProfile(response, kaptureIntegration),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

// Assigning userInfo.
export const userAssign = (data) => (
  setUserInfo(data)
);

//Storing new user account details.
export const accountDetails = (data, onSuccess, onError, fromProfileCreate) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/user",
    data,
    success: (response) => setUserInfoOnConfirm(response, fromProfileCreate),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const loginUser = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/api/users/login",
    data,
    success: (response) => setUserInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const resetPayment = (data) => {
  return { type: constants.RESET_PAYMENTS };
};
export const removeLocalStorage = () => {
  localStorage.removeItem("USER_INFO");
  localStorage.removeItem("USER_FROM_WEB");
  localStorage.removeItem("USER_FROM_WEB_ID");
  localStorage.removeItem("USER_FROM_WEB_REFRESH")
};
export const logoutUser = () => {

  localStorage.removeItem("USER_INFO_PROFILE");

  // Remove kapture script and kapture widget from DOM.
  if (document.getElementById("kap-snippet")) {
    document.getElementById("kap-snippet").remove();
  }

  if (document.getElementById("parent_kapchat_container")) {
    document.getElementById("parent_kapchat_container").remove();
  }

  localStorage.removeItem("USER_INFO");
  localStorage.removeItem("USER_FROM_WEB");
  localStorage.removeItem("USER_FROM_WEB_ID");
  localStorage.removeItem("USER_FROM_WEB_REFRESH")

  trackEvent('Logout');
  trackDwebEvent('Logout', {});
  logoutEvent();
  window.location.replace(PARENT_WEBSITE() + "?logout")
  return { type: constants.RESET_USER_INFO };
};

const returnInfo = (data) => {
  return { type: constants.RETURN_INFO, payload: data };
};

//On clicking confirm button in account details.
const setUserInfoOnConfirm = (data, fromProfileCreate) => {
  logger.log("AuthActionCreator", "confirmed", data);
  if (data.response.user.companyName != null) {
    const user = JSON.parse(localStorage.getItem("USER_INFO"));
    let userCloned = { ...user }
    userCloned.userInfo.city_name = data.response.user.city_name;
    userCloned.userInfo.companyName = data.response.user.companyName;
    userCloned.userInfo.profileAttributes = data.response.user.profileAttributes
    userCloned.userInfo.name = data.response.user.name;
    userCloned.userInfo.no_of_vehicles = data.response.user.number_of_vehicles;
    userCloned.userInfo.state_name = data.response.user.state_name;
    userCloned.userInfo.s3ProfileLink = data.response.user.s3ProfileLink;
    userCloned.isNewUser = false;
    if (fromProfileCreate) {
      userCloned.showAddTripOverlay = true;
    } else {
      userCloned.showAddTripOverlay = false;
    }

    // localStorage.setItem("USER_INFO", JSON.stringify(userCloned));
    // setUserInfo(userCloned); 
    // logger.log("AuthActionCreator", "Json user", user);
    // user.isNewUser = false;
    // localStorage.setItem("USER_INFO", JSON.stringify(user));
    return {
      type: constants.SET_USER_INFO_AFTER_ACCOUNT, payload: { data, addTripOverlay: fromProfileCreate }
    };
  }
}


const setUserInfo = (data, loginFromWeb) => {
  logger.log("AuthActionCreator", "the data is", data);
  let userInfo = {
    userId: null,
    fullName: null,
    token: null,
    tokenInfo: null,
    userInfo: null,
    isLoggedIn: false,
    isNewUser: false,
    showAddTripOverlay: false
  };
  if (data && data.status && data.status.code === 200) {

    if (data && data.response && data.response.token && data.response.user) {
      userInfo = {
        userId: data.response.user.id,
        fullName: data.response.user.id,
        token: data.response.token,
        tokenInfo: data.response.token,
        userInfo: data.response.user,
        isLoggedIn: true,
        isNewUser: false,
        showAddTripOverlay: false
      };
      if (loginFromWeb) {
        userInfo['loginFromWeb'] = loginFromWeb ? loginFromWeb : false
      }
      if (
        // data.response.user.companyName &&
        data.response.user.companyName === "" ||
        data.response.user.companyName === null
      ) {
        userInfo.isNewUser = true;
      };
      localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
      // if (typeof window !== 'undefined' && typeof window.xdLocalStorage !== 'undefined') {
      //   window.xdLocalStorage.setItem('USER_INFO', JSON.stringify(userInfo.token));
      // }
    };
  }
  return { type: constants.SET_USER_INFO, payload: userInfo };
};

const setUserInfoProfile = (data, kaptureIntegration) => {
  let payloadData = data.response;
  if (kaptureIntegration) {
    localStorage.setItem('USER_INFO_PROFILE', JSON.stringify(data.response));
  }
  return { type: constants.GET_USER_DETAILS_FOR_PROFILE, payload: payloadData };
}

/**
 * Load Application Configs after successful login
 * @param {*} onSuccess 
 * @param {*} onError 
 */
export const loadConfigs = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/configs",
    data: null,
    success: (response) => { return { type: constants.LOAD_CONFIGS, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const loadConfigsProfile = (onSuccess, onError, data = { filteredKeys: ["profile_create_config"] }) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/configs/filtered",
    data,
    success: (response) => { return { type: constants.LOAD_CONFIGS_PROFILE, payload: response && response.response && response.response.profile_create_config ? response.response.profile_create_config : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const userProfile = (onSuccess, onError, data = { filteredKeys: ["tpbook_pro_config"] }) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/configs/filtered",
    data,
    // success: (response) => { return { type: constants.LOAD_CONFIGS_PROFILE, payload: response.response ? response.response : [] } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const createBankDetails = (accountData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendorbankdetails",
    data: accountData,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const fetchVendorBank = (ifsc, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/fetchBankName/" + ifsc,
    // data: null,
    success: (response) => { return { type: null, payload: null } },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const fetchBankAccounts = (id, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/fetch/vendorbankdetails",
    data: id,
    success: (response) => processFetchBankAccounts(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const editBankAccount = (id, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendorbankdetails/" + id,
    data,
    success: (response) => processNotUsedResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const markDefault = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendorbankdetails/default",
    data,
    success: (response) => processNotUsedResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

export const toggleSearchBar = (data) => {
  logger.log("AuthActionCreator", 'data', data);
  return { type: constants.TOGGLE_SEARCH_BAR, payload: data }
}

export const processAddPassBookPhoto = (photo) => {
  return { type: constants.ADD_PASSBOOK_PHOTO_UPLOAD, payload: photo };
}

export const Loader = (type) => {
  return { ...type }
}

const processFetchBankAccounts = (data) => {
  return { type: constants.BANK_ACCOUNTS, payload: data.response }
}

const processNotUsedResponse = () => {
  return { type: null, payload: null }
}

export const toggleOverlay = (data) => {
  return { type: constants.TOGGLE_OVERLAY, payload: data }
}
export const updateAccessToken = (data) => {
  return { type: constants.TOGGLE_OVERLAY, payload: data }
}

export const refreshAuthToken = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/generate_access_token",
    success: (response) => processRefreshToken(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
})

const processRefreshToken = (response) => {
  return { type: constants.REFRESH_TOKEN, payload: response }
}
